module.exports = "/fonts/Roboto-BoldItalic.ttf?41db5f5406168140f3bac715979f8f36";